type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** One automatic document recovery per failed-package chain. Only an actual
 * successful package import ends the chain, not a return to the Station or a
 * wall-clock cooldown. If storage is blocked, manual recovery remains safe.
 */
export class ModuleRecoveryGuard {
  private readonly key = 'scrapline:runtime-retry';

  public constructor(private readonly getStorage: () => RecoveryStorage, private readonly reload: () => void) {}

  public retryAfterReload(): boolean {
    try {
      const storage = this.getStorage();
      if (storage.getItem(this.key) !== null) return false;
      storage.setItem(this.key, '1');
      this.reload();
      return true;
    } catch {
      return false;
    }
  }

  public clearAfterSuccess(): void {
    try { this.getStorage().removeItem(this.key); }
    catch { /* Successful boarding must not depend on writable session storage. */ }
  }
}
